module.exports = __webpack_public_path__ + "media/components/src/assets/images/gift-card/gift-card-black-052c1745cec7ab868094424150a76ad7.svg";